var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnifying(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3637 12.8769C9.91536 13.944 8.11728 14.4243 6.32974 14.2217C4.5422 14.0191 2.89722 13.1485 1.72437 11.7843C0.551507 10.4201 -0.0626081 8.66309 0.00505098 6.86525C0.07271 5.06741 0.817146 3.36153 2.08922 2.08937C3.36129 0.817204 5.06705 0.0727152 6.86476 0.00505134C8.66247 -0.0626125 10.4194 0.551546 11.7835 1.72449C13.1475 2.89743 14.0181 4.54252 14.2207 6.33019C14.4233 8.11786 13.943 9.91606 12.8759 11.3646L19.6595 18.1471C19.7646 18.2451 19.8489 18.3632 19.9074 18.4945C19.9659 18.6257 19.9973 18.7674 19.9998 18.9111C20.0024 19.0548 19.9759 19.1975 19.9221 19.3307C19.8683 19.464 19.7882 19.585 19.6866 19.6866C19.585 19.7882 19.464 19.8683 19.3308 19.9221C19.1975 19.9759 19.0548 20.0024 18.9112 19.9998C18.7675 19.9973 18.6258 19.9659 18.4946 19.9074C18.3633 19.8489 18.2452 19.7646 18.1473 19.6594L11.3637 12.8769ZM12.127 7.13295C12.127 8.4573 11.6009 9.72741 10.6645 10.6639C9.72814 11.6003 8.45812 12.1264 7.13386 12.1264C5.80961 12.1264 4.53959 11.6003 3.60319 10.6639C2.6668 9.72741 2.14074 8.4573 2.14074 7.13295C2.14074 5.80859 2.6668 4.53848 3.60319 3.60203C4.53959 2.66557 5.80961 2.13947 7.13386 2.13947C8.45812 2.13947 9.72814 2.66557 10.6645 3.60203C11.6009 4.53848 12.127 5.80859 12.127 7.13295Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifying);
export default __webpack_public_path__ + "static/media/Magnifying.dffd9566ffd6d226008c2f6f76b833d9.svg";
export { ForwardRef as ReactComponent };